import React, { useCallback } from 'react';
import { DialogCancelMeeting, FormModel } from 'components/dialog-cancel-meeting';
import { useEffectError } from 'hooks';
import { isMutationFulfilled } from 'utils/rtk-query';
import { apiSupportMeeting } from 'services/support-meetings';

const useCancelMutation = apiSupportMeeting.useCancelSupportMeetingMutation;
interface Props {
  supportMeetingTypeID: string;
  userPatientProfileID: string;
  meetingID: string;
  onClose: () => void;
  onDone: () => void;
}
export const DialogCancelMeetingContainer: React.FC<React.PropsWithChildren<Props>> = ({
  meetingID,
  supportMeetingTypeID,
  userPatientProfileID,
  onClose,
  onDone,
}) => {
  const [triggerCancel, resultCancel] = useCancelMutation();
  useEffectError(resultCancel.error);

  const onSubmit = useCallback(
    async (formData: FormModel) => {
      const res = await triggerCancel({
        id: formData.meetingID,
        remarks: formData.remarks,
        statusID: formData.remarkForPatientCallStatusID,
        supportMeetingTypeID: supportMeetingTypeID,
        userPatientProfileID: userPatientProfileID,
      });

      if (isMutationFulfilled(res)) {
        onDone();
        onClose();
      }
    },
    [triggerCancel, onDone, onClose, supportMeetingTypeID, userPatientProfileID],
  );

  return (
    <DialogCancelMeeting
      meetingID={meetingID}
      isLoading={resultCancel.isLoading}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
};
